import React from 'react'

/**
 * Footer del login con copyright
 * Siguiendo Regla #3: Componente específico <200 líneas
 * Siguiendo Regla #2: Solo presentación
 *
 * @returns {JSX.Element} Footer
 */
const Footer = () => {
  return (
    <div className="mt-2 text-center text-sm text-gray-500">
      <p className="font-roboto">© 2024 Help MED - Emergencias Médicas</p>
    </div>
  )
}

export default Footer
